(() => {
  const ROOT = '[data-bw-colour-showcase]';
  const PHOTO_URLS = [
    'https://cdn.shopify.com/s/files/1/0903/1270/4377/files/breakwells-finish-anthracite-spray.jpg?v=1788358162',
    'https://cdn.shopify.com/s/files/1/0903/1270/4377/files/breakwells-finish-black-gloss.jpg?v=1788358162',
    'https://cdn.shopify.com/s/files/1/0903/1270/4377/files/breakwells-finish-white-gloss.jpg?v=1788358162',
    'https://cdn.shopify.com/s/files/1/0903/1270/4377/files/breakwells-finish-blue-gloss.jpg?v=1788358161',
    'https://cdn.shopify.com/s/files/1/0903/1270/4377/files/breakwells-finish-red-gloss.jpg?v=1788358162',
    'https://cdn.shopify.com/s/files/1/0903/1270/4377/files/breakwells-finish-green-gloss.jpg?v=1788358162',
    'https://cdn.shopify.com/s/files/1/0903/1270/4377/files/breakwells-finish-silver-metallic.jpg?v=1788358161',
    'https://cdn.shopify.com/s/files/1/0903/1270/4377/files/breakwells-finish-pearl-white.jpg?v=1788358161'
  ];
  const mod = (n, m) => ((n % m) + m) % m;

  function enhance(root) {
    if (!root || root.dataset.bwSwipeEnhanced === 'true') return;
    root.dataset.bwSwipeEnhanced = 'true';
    const wheel = root.querySelector('[data-bw-wheel]');
    const buttons = [...root.querySelectorAll('[data-bw-colour-button]')];
    if (!wheel || !buttons.length) return;
    buttons.forEach((button, index) => {
      if (!button.dataset.image && PHOTO_URLS[index]) button.dataset.image = PHOTO_URLS[index];
    });
    const initial = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
    if (initial) initial.click();

    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let lastX = 0;
    let lastY = 0;
    let dragging = false;
    let suppressClickUntil = 0;
    const reset = () => {
      pointerId = null;
      dragging = false;
      root.classList.remove('is-swipe-dragging');
    };
    wheel.addEventListener('pointerdown', (event) => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = lastX = event.clientX;
      startY = lastY = event.clientY;
    });
    wheel.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      lastX = event.clientX;
      lastY = event.clientY;
      const dx = lastX - startX;
      const dy = lastY - startY;
      if (!dragging && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.15) {
        dragging = true;
        root.classList.add('is-swipe-dragging');
        if (wheel.setPointerCapture) wheel.setPointerCapture(pointerId);
      }
      if (dragging) event.preventDefault();
    });
    const finish = (event) => {
      if (event.pointerId !== pointerId) return;
      const dx = lastX - startX;
      const dy = lastY - startY;
      if (dragging && Math.abs(dx) >= 32 && Math.abs(dx) > Math.abs(dy)) {
        const activeIndex = Math.max(0, buttons.findIndex((button) => button.classList.contains('is-active')));
        const steps = Math.min(2, Math.max(1, Math.round(Math.abs(dx) / 120)));
        const direction = dx < 0 ? 1 : -1;
        suppressClickUntil = performance.now() + 320;
        buttons[mod(activeIndex + direction * steps, buttons.length)].click();
      }
      if (wheel.releasePointerCapture && wheel.hasPointerCapture && wheel.hasPointerCapture(event.pointerId)) {
        wheel.releasePointerCapture(event.pointerId);
      }
      reset();
    };
    wheel.addEventListener('pointerup', finish);
    wheel.addEventListener('pointercancel', reset);
    wheel.addEventListener('click', (event) => {
      if (event.isTrusted && performance.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  const initAll = (scope = document) => scope.querySelectorAll(ROOT).forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

(() => {
  const ROOT = '[data-bw-colour-showcase]';
  const INTERVAL = 4600;
  const USER_DELAY = 6200;
  function initAutoplay(root) {
    if (!root || root.dataset.bwAutoplayEnhanced === 'true') return;
    root.dataset.bwAutoplayEnhanced = 'true';
    const buttons = [...root.querySelectorAll('[data-bw-colour-button]')];
    if (buttons.length < 2) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = 0;
    let mouseOver = false;
    let focusWithin = false;
    let pointerDown = false;
    let visible = true;
    let holdUntil = 0;
    const clear = () => { window.clearTimeout(timer); timer = 0; };
    const isPaused = () => reduced || mouseOver || focusWithin || pointerDown || !visible || document.visibilityState === 'hidden';
    const schedule = (delay = INTERVAL) => {
      clear();
      if (reduced) return;
      timer = window.setTimeout(() => {
        const remainingHold = holdUntil - performance.now();
        if (isPaused() || remainingHold > 0) {
          schedule(Math.max(700, remainingHold));
          return;
        }
        const current = Math.max(0, buttons.findIndex((button) => button.classList.contains('is-active')));
        buttons[(current + 1) % buttons.length].click();
        schedule(INTERVAL);
      }, Math.max(250, delay));
    };
    const hold = (duration = USER_DELAY) => {
      holdUntil = Math.max(holdUntil, performance.now() + duration);
      schedule(duration + 60);
    };
    root.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      mouseOver = true;
      clear();
    });
    root.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      mouseOver = false;
      schedule();
    });
    root.addEventListener('focusin', () => { focusWithin = true; clear(); });
    root.addEventListener('focusout', () => {
      focusWithin = root.contains(document.activeElement);
      if (!focusWithin) schedule();
    });
    root.addEventListener('pointerdown', () => { pointerDown = true; hold(); });
    root.addEventListener('pointerup', () => { pointerDown = false; hold(); });
    root.addEventListener('pointercancel', () => { pointerDown = false; hold(); });
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => { if (event.isTrusted) hold(); });
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        visible = entries.some((entry) => entry.isIntersecting);
        if (visible) schedule();
        else clear();
      }, { threshold: 0.22 });
      observer.observe(root);
    }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') schedule();
      else clear();
    });
    schedule();
  }
  const initAll = (scope = document) => scope.querySelectorAll(ROOT).forEach(initAutoplay);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
